import {
  Badge,
  BlockStack,
  Button,
  Card,
  InlineStack,
  Link,
  Page,
  Pagination,
  Text,
  Thumbnail,
  Tooltip,
  EmptyState,
} from '@shopify/polaris';
import { AlertMinor, MobileBackArrowMajor } from '@shopify/polaris-icons';
import NoResultsFound from '../../../../../Asests/Images/NoResultsFound.png';
import React, { useEffect, useState, useRef } from 'react';
import { AmazonIconDark } from '../../../../../Asests/svgIcon/icon';
import VarientTable from './VariantTable';
import VarientTableSkelton from './VariantTableSkelton';
import Noimage from '../../../../../../public/files/noImage.png';
import { DI, DIProps } from '../../../../../Core';
interface Props extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: () => void;
  selectedRows?: any[];
}
import VariantGridFilter from './VariantGridFilter';
import { GridApis } from '../../Utilities/Apis';
import { modifyImageUrl } from '../../Utilities/Helper';
import { useTranslation } from 'react-i18next';
import { GetActivityFromRowDatavarient, SetBadgeVariation } from './HelperFunction';
import { gridFilters, gridFiltersVariation, } from '../../Utilities/Constants';
import { allfilterI } from '../../Utilities/Interface';
import { amazon_regions } from '../../../Onboarding/components/onboardinghelper';
import { cloneDeep } from 'lodash';
import { useDebounce } from '../../../../Panel/useDebounce';
import ProductErrorsN from '../../../Editproduct/components/ProductDetails/ProductErrorsN';
import ActivityFeeds from '../ActivityFeeds';
import Amazon from '../../../../../Asests/Images/amazon.png';
import Shopify from '../../../../../Asests/Images/shopify.png';
import { getAmazonLink } from '../../../../../../src/Components/Panel/Editproduct/utils/utils';
import { isAdminLoggedIn } from '../../../Panel/index';
import Adminactions from '../Adminactions';


const countPerPage: number = 50;

const VariantGrid = (props: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [dataforRow, setDataforRow] = useState([]);
  const [selectedRows, setselectedRows] = useState<Array<string>>([]);
  const [FiftyPlus, setFiftyPlus] = useState<boolean>(false)
  const [appliedFilters, setAppliedFilters] = useState<any>([]);
  const [totalVariantCount, settotalVariantCount] = useState<any>();
  const [page, setpage] = useState<any>(parseInt(props.di.globalState.get("paginationVariant", true) ?? "1"));
  const [totalPages, settotalPages] = useState<number>(0);
  const [hasPrevious, sethasPrevious] = useState(false);
  const [hasNext, sethasNext] = useState(false);
  const [allFiltersNew, setallFilters] = useState<allfilterI>(
    Object.keys(JSON.parse(props.di.globalState.get('filtersVariants', true) ?? '{}'))?.length > 0 ?
      JSON.parse(props.di.globalState.get('filtersVariants', true) ?? '{}')
      :
      cloneDeep(gridFiltersVariation)
  );
  function fetchProducts() {
    setLoading(true)
    let filter = Preparefilter(allFiltersNew)
    props.di.POST(`${GridApis.getRefineVariant}`, {
      "filter": filter,
      "remove_parent": true,
      "container_id": props?.location?.state?.container_id,
      "activePage": page || 1,
      "count": 50
    })
      .then((products) => {
        if (products.success) {
          setDataforRow(products?.data?.rows)
          // handleTotalpage(products?.data?.totalCount)handleTotalpage
        } else {
          props.error(products.message)
        }
      })
  }

  function fetchProductCount() {
    let filter = Preparefilter(allFiltersNew)
    props.di.POST(`${GridApis.getRefineVariantCount}`, {
      "filter": filter,
      "container_id": props?.location?.state?.container_id,
      "remove_parent": true,
    })
      .then((count) => {
        if (count.success) {
          settotalVariantCount(count?.data?.count)
          if (count.data.count > 0) {
            handleTotalpage(count['data']['count']);
          } else if (count.data.count == 0) {
            handleTotalpage(count['data']['count']);
          }
        } else {
          props.error(count.message)
        }
      })
  }

  const [lastActivities, setLastActivities] = useState({})
  const getVariantProdOpt = () => {
    return [
      { label: 'Select variant', value: 'select', disabled: true },
      ...(dataforRow?.map((variant: any) => {
        return {
          label: variant?.items?.variant_title,
          value: variant?.items?.source_product_id,
          img: variant?.items?.main_image
        }
      }))
    ];
  }
  const [activeToast, setActiveToast] = useState({ open: false, refresh: false });
  const wsRef = useRef<WebSocket | null>(null);
  const [latestData, setLatestData] = useState<any>('{}');
  const [lastActivity, setLastActivity] = useState<number>(Date.now());
  useEffect(() => {
    const connect = async () => {
      if (!wsRef.current || wsRef.current.readyState === WebSocket.CLOSED) {
        wsRef.current = new WebSocket('wss://a5zls8ce93.execute-api.us-east-2.amazonaws.com/beta');
        wsRef.current.onopen = () => {
          const clientIdString: string | undefined = process.env.REACT_APP_WEBSOCKET_CLIENT_ID;
          if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN && clientIdString) {
            const dataTosend: any = {
              "action": "identity", "client_id": parseInt(clientIdString), "customer_id": props.di.globalState.get("user_id"),
              "token": props.di.globalState.getBearerToken()
            }
            wsRef.current.send(JSON.stringify(dataTosend));
          }
          setActiveToast({ ...activeToast, open: false })
        };

        wsRef.current.onmessage = (event) => {

          // Triggering the onDataReceived function here
          setLatestData(event.data);
        };

        wsRef.current.onerror = (error) => {
          console.error('WebSocket error:', error);
        };

        wsRef.current.onclose = () => {
          if (Date.now() - lastActivity > 600000) { // 30 minutes in milliseconds
            setActiveToast({ ...activeToast, open: true })
          } else {
            connect();
          }
        };
      }
    };

    connect();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [activeToast.refresh]);

  useEffect(() => {
    if (!latestData) return;

    const parsedData = JSON.parse(latestData);
    if (!Array.isArray(parsedData?.notification)) return;

    const updatedData: any = dataforRow.map((data: any) => {
      const feedItem = parsedData.notification.find(
        (element: any) => data?.items?.source_product_id === element?.source_product_id
      );
      if (!feedItem) return { ...data };

      let updatedItem = { ...data };
      const {
        items: { error: existingErrors = [], warning: existingWarnings = [], process_tags = {} } = {},
      } = data;
      const { error = [], warning = [], process_tags: newProcessTags, unset = {} } = feedItem;

      // Merge errors
      if (error.length > 0) {
        updatedItem = {
          ...updatedItem,
          items: {
            ...updatedItem.items,
            error: [...existingErrors, ...error],
          },
        };
      }

      // Merge warnings
      if (warning.length > 0) {
        updatedItem = {
          ...updatedItem,
          items: {
            ...updatedItem.items,
            warning: [...existingWarnings, ...warning],
          },
        };
      }

      // Merge process_tags
      if (newProcessTags) {
        updatedItem = {
          ...updatedItem,
          items: {
            ...updatedItem.items,
            process_tags: {
              ...process_tags,
              ...newProcessTags,
            },
          },
        };
      }

      // Handle unset items
      Object.keys(unset).forEach((key) => {
        if (key === 'process_tags') {
          delete updatedItem.items?.process_tags;
        } else if (key === 'error') {
          delete updatedItem.items?.error;
        } else if (key === 'warning') {
          delete updatedItem.items?.warning;
        }
      });

      return updatedItem;
    });

    setDataforRow(updatedData);
  }, [latestData, loading]);

  const RenderSKU = ({ row }: any) => {
    let returnJSX: any = <></>
    let badge: any = row?.items?.status;
    if (['Active', 'Inactive', 'Incomplete', 'Listed', 'Partial Listed', 'Partial Uploaded', "Uploaded"].includes(badge)) {
      returnJSX = (
        <BlockStack gap={'200'}>
          <InlineStack gap={'200'}>
            <img alt='amazon' height={'20px'} width={'20px'} src={Amazon} />
            <Text as='span' tone="subdued">{row?.items?.['sku'] || t("N/A")}</Text>
          </InlineStack>
          {row?.items?.['shopify_sku'] && <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            <Text as='span' tone="subdued">{row?.items?.['shopify_sku'] || t("N/A")}</Text>
          </InlineStack>}
        </BlockStack>)
    } else {
      returnJSX =
        <BlockStack gap={'200'}>
          <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            <Text as='span' tone="subdued">{row?.items?.['sku'] || t("N/A")}</Text>
          </InlineStack>
          {/* {row?.items?.['shopify_sku'] && <InlineStack gap={'200'}>
            <img alt='shopify' height={'20px'} width={'20px'} src={Shopify} />
            <Text as='span' tone="subdued">{row?.items?.['shopify_sku'] || t("N/A")}</Text>
          </InlineStack>} */}
        </BlockStack>
    }

    return returnJSX;
  }

  const refreshAction = () => {
    fetchProductCount()
    fetchProducts()
  }

  useEffect(() => {
    let tempData: any = [];
    let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
    dataforRow.forEach((row: any) => {
      tempData.push({
        key: row?.items?.source_product_id,
        image: (
          <div className="product-img-container">
            <img width="100%" height="100%" src={row?.items?.main_image ? modifyImageUrl(row?.items?.main_image) : Noimage} alt="product" />
          </div>
        ),
        // sku: <Text as='p'>{row?.items?.sku}</Text>,
        sku: <RenderSKU row={row}></RenderSKU>,
        product_title: row?.title,
        asin: row?.items?.asin ? row?.items?.asin?.length == 10 ? <Link target='_blank' onClick={() => window.open(`https://${getAmazonLink(props)}/dp/${row?.items?.asin}`)}>{row?.items?.asin}</Link> : <Text as="p">{row?.items?.asin}</Text> : <Text as="p">{t("N/A")}</Text>,
        barcode: <Text as="p">{row?.items?.barcode || t("N/A")}</Text>,
        variant_title: (
          <React.Fragment>
            {(
              <div
                className="product_title"
                onClick={() => props.history(`../product${"/new"}/${row['container_id']}/variant/${row?.['items']?.['source_product_id']}`
                  , {
                    state: {
                      options: getVariantProdOpt(),
                      source_product_id: row.source_product_id,
                      errorExists: Object.keys(row.items)?.includes("error") ? true : false,
                      progressExists: Object.keys(row.items)?.includes("process_tag") ? true : false,
                      warningExists: Object.keys(row.items)?.includes("warning") ? true : false,
                    }
                  }
                )}
                style={{ cursor: 'pointer' }}
              >
                {row?.items?.variant_title ? row?.items?.variant_title : 'N/A'}
              </div>
            )}
          </React.Fragment>
        ),
        status: <div className='status'><SetBadgeVariation t={t} {...props} item={row} direct={true} /></div>,
        quantity: <Text as='p'>{row?.items?.quantity || "0"}</Text>,
        price: <Text as="p">{row?.items?.price >= 0 ? ` ${current_shop_currency?.['currency_symbol']}${row?.items?.price}` : t("N/A")}</Text>,
        activity: <GetActivityFromRowDatavarient refreshAction={refreshAction} t={t} row={row} />,
        feed: <ActivityFeeds row={row} lastActivities={lastActivities} setLastActivities={setLastActivities} />,
        fulfilment: <Text as='p'>{(props?.location?.state?.fulfillment_type ? props?.location?.state?.fulfillment_type : row?.items?.fulfillment_type) || "FBM"}</Text>,
        source_product_id: row?.source_product_id
      });
    });
    setRowData(tempData)
    setLoading(false)
  }, [dataforRow])

  const debouncedFilters = useDebounce(props.di.globalState.get('filtersVariants', true), 1000);
  const debouncedPagination = useDebounce(props.di.globalState.get('paginationVariant', true), 1000);

  useEffect(() => {
    if (page > 0) {
      fetchProducts()
      fetchProductCount()
      getDataFromLocalStorage()
    }

  }, [debouncedFilters, debouncedPagination])

  // preparation of the filter query
  const Preparefilter = (custom_filter: allfilterI = allFiltersNew) => {
    let filterdata: any = {};
    Object.keys(custom_filter).forEach((key: string) => {
      let tempData: any = {};
      if (custom_filter?.[key]?.change) {
        if (key === 'Optimised' && custom_filter?.[key]?.textValue === 'false') tempData[2] = true;
        else tempData[custom_filter?.[key]?.selectValue] = custom_filter?.[key]?.textValue;
      }
      if (Object.keys(tempData).length > 0) filterdata[custom_filter?.[key]?.value] = tempData
    });
    return filterdata;
  };

  const handleTotalpage = (totalPages: number) => {
    if (totalPages > 0) {
      if (totalPages % countPerPage == 0) {
        totalPages = totalPages / countPerPage;
      } else {
        totalPages = Math.trunc(totalPages / countPerPage) + 1;
      }
      window.scrollTo(0, 0);
      settotalPages(totalPages);
      if (totalPages < page) {
        setpage(1)
        sethasPrevious(false)
      }
      else if (totalPages == page)
        sethasNext(false)
      else if (totalPages > page)
        sethasNext(true)
    }
    else {
      window.scrollTo(0, 0);
      settotalPages(0);
    }
  };

  //this function gets pagination data from local storage
  const getDataFromLocalStorage = () => {
    let param: any = {};
    if (props.di.globalState.get("paginationVariant", true)) {
      page > 1 && sethasPrevious(true);
      page == 1 && sethasPrevious(false);
      param = { activePage: props.di.globalState.get("inputpage", true) }
    }
  };



  //this function handle the pagination next event
  const handlePaginationNext = () => {
    if (page <= totalPages) {
      sethasPrevious(true);
      setpage(page + 1);
      props.di.globalState.set('paginationVariant', JSON.stringify(page), true);

    } else {
      sethasNext(false);
    }

  };

  //this function handle the pagination previous event
  const handlePaginationPrevious = () => {
    if (page > 0) {
      sethasPrevious(true);
      setpage(page - 1);
      props.di.globalState.set('paginationVariant', JSON.stringify(page), true);

    } else {
      sethasNext(false);
    }
    // if (props.di.globalState.get("inputpage", true)) {
    //     if (page > 1) {
    //         setpage(page - 1);
    //         props.di.globalState.set("inputpage", (page - 1).toString())
    //     }
    //     else sethasPrevious(false)
    // }
  };

  const handleFiftyPlus = () => {
    let TempRow: any = []
    rowData.forEach((row: any) => { TempRow.push(row?.key) })
    setselectedRows(TempRow);
    setFiftyPlus(true)
  }

  const renderTable = () => {
    if (loading) {
      return <VarientTableSkelton t={t} />
    } else {
      if (rowData.length > 0 || loading) {
        return (
          <div className='table-wrapper' id="tour">
            <BlockStack gap="300" align='center'>
              <BlockStack gap="200">
                <VarientTable refreshAction={refreshAction} allFiltersNew={allFiltersNew} totalPages={totalPages} dataforRow={dataforRow} selectedRows={selectedRows} setselectedRows={setselectedRows} handleFiftyPlus={handleFiftyPlus} setFiftyPlus={setFiftyPlus} FiftyPlus={FiftyPlus} rows={rowData} />
                <InlineStack
                  align="center"
                  gap="400">
                  <Pagination
                    label={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="Polaris-TextField">
                          <input
                            className="psedu-polaris-textfield Polaris-TextField__Input Polaris-TextField__Input--alignCenter"
                            style={{ maxWidth: '50px' }}
                            type='number'
                            min="1"
                            onBlur={() => {
                              if (page == 0 || page == undefined || page == "") {
                                setpage(1)
                                fetchProducts()
                                fetchProductCount()
                                getDataFromLocalStorage()
                              }
                            }}
                            onChange={(value: any) => {
                              const inputValue = value.target.value.trim(); // No parseInt here
                              let pageValue: number | string = ""
                              if (inputValue != "") {
                                const parsedInput = parseInt(inputValue);
                                if (!isNaN(parsedInput)) {
                                  if (parsedInput < 1) {
                                    pageValue = 1;
                                  } else if (parsedInput > totalPages) {
                                    pageValue = totalPages;
                                  } else {
                                    pageValue = parsedInput;
                                  }
                                }
                                props.di.globalState.set("paginationVariant", pageValue.toString())
                              }
                              setpage(pageValue)
                            }}
                            value={page}
                          />
                          <div className="Polaris-TextField__Backdrop"></div>
                        </div>
                        <div style={{ margin: '0 0 0 10px' }}>
                          <Text as='span' tone="subdued">{` / ${totalPages} ${t("page(s)")}`}</Text>
                        </div>
                      </div>
                    }
                    hasPrevious={hasPrevious}
                    onPrevious={handlePaginationPrevious}
                    hasNext={hasNext}
                    onNext={handlePaginationNext}
                  />
                </InlineStack>
              </BlockStack>
            </BlockStack>
          </div>
        );
      } else {
        return (
          <InlineStack align="center">
            <EmptyState image={NoResultsFound} heading={t('No Products Found')} />
          </InlineStack>
        );
      }
    }

  };


  const [showError, setshowError] = useState(false)

  return (
    <Page fullWidth>
      <InlineStack gap={'300'} wrap>
        <ProductErrorsN
          {...props}
          from='grid'
          type={'parent'}
          id={props?.location?.state?.['container_id']}
          viewProductError={showError}
          setViewProductError={setshowError}
        />
        <div className="custom-varient__product-title">
          <BlockStack gap={'400'}>
            <InlineStack
              align="space-between"
              blockAlign="center"
              gap={'400'}
              wrap={false}>
              <InlineStack gap={'300'} blockAlign="center">
                <Button
                  icon={MobileBackArrowMajor}
                  variant="tertiary"
                  size="large"
                  onClick={() => { props?.di?.globalState?.removeLocalStorage("paginationVariant"); props?.di?.globalState?.removeLocalStorage("filterVariant"); props.history(-1) }}
                />
                <InlineStack gap={'300'} wrap={false}>
                  <Thumbnail
                    source={
                      props?.location?.state?.image ?? Noimage
                    }
                    alt="main-product-image"
                    size="small"
                  />
                </InlineStack>
                <InlineStack gap={'400'}>
                  <Text as="h4" variant="headingMd">
                    {props?.location?.state?.title?.length > 50 ? <Tooltip content={props?.location?.state?.title}><Text as='p'>{props?.location?.state?.title?.substring(0, 50) + "..."}</Text></Tooltip> : <Text as="p">{props?.location?.state?.title}</Text>}
                  </Text>
                  <div className="custom-variant-status">
                    <InlineStack gap={'100'}>
                      <AmazonIconDark />
                      <Text
                        as="span"
                        variant="bodyMd"
                        tone="subdued">
                        {t(props?.location?.state?.status?.label)}
                      </Text>
                    </InlineStack>
                  </div>
                  {props.location?.state?.errorExists && <span className={`gridErrorBadge custom-main-prod__errorBadge`} onClick={() => setshowError(true)}>
                    <Badge
                      tone="critical"
                      icon={AlertMinor}
                      size="large">
                      {t("Error")}
                    </Badge>

                  </span>}
                </InlineStack>
              </InlineStack>
              {/* Now new edit will be opened always */}
              <InlineStack>
                {(() => {
                  const state = props?.location?.state;
                  const isAdmin = isAdminLoggedIn();
                  const isAIUpdated = state?.ai_updated_product;
                  const containerId = state?.container_id;

                  const commonState = {
                    source_product_id: containerId,
                    status: state?.parentData,
                    errorExists: state?.errorExists,
                    progressExists: state?.progressExists,
                    warningExists: state?.warningExists,
                  };

                  const buttons = [];

                  if (isAdmin && !isAIUpdated) {
                    // Show both buttons
                    buttons.push(
                      <Button
                        key="edit"
                        size="large"
                        onClick={() => props.history(`../product/${containerId}`, { state: commonState })}
                      >
                        {t("Old Edit Product")}
                      </Button>
                    );

                    buttons.push(
                      <Button
                        key="edit-ai"
                        size="large"
                        onClick={() => props.history(`../product/new/${containerId}`, { state: commonState })}
                      >
                        {t("Edit Product")}
                      </Button>
                    );
                  } else {
                    // All other cases (admin+AIUpdated OR notAdmin) → only Edit AI
                    buttons.push(
                      <Button
                        key="edit-ai"
                        size="large"
                        onClick={() => props.history(`../product/new/${containerId}`, { state: commonState })}
                      >
                        {t("Edit Product")}
                      </Button>
                    );
                  }

                  return buttons;
                })()}
              </InlineStack>


            </InlineStack>
            {(props.di.globalState.get(
                'admin_login',
                true
              ) || process.env.REACT_APP_PROD === "0") && (

                  <div >
                    <InlineStack gap="100">
                      <Adminactions
                        {...props}
                        selectedRowKeys={
                          []
                        }
                        selectedFlagChild={
                          selectedRows
                        }
                        activityRefreshAction={
                          refreshAction
                        }
                      />
                    </InlineStack>
                  </div>
                )}
            <BlockStack gap={'300'}>
              <Text as="h6" variant="bodyLg" fontWeight="medium">
                {t("List of Variants")} ({totalVariantCount || 0})
              </Text>
              <div className="Custom-Polaris-Box">
                <Card >
                  <VariantGridFilter loading={loading} appliedFilters={appliedFilters} setAppliedFilters={setAppliedFilters} {...props} allFiltersNew={allFiltersNew} setallFilters={setallFilters} />
                  {renderTable()}
                </Card>
              </div>

              {/*  */}
            </BlockStack>
          </BlockStack>
        </div>
      </InlineStack>

    </Page>
  );
};
export default DI(VariantGrid);


